import React, { Component } from "react";
import { Button,Form,Icon,Pagination,Select,Table } from "semantic-ui-react";
import { DeviceContext } from "context/deviceProvider";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/deviceStatus/devicesStatus.scss";
import LetterLoading from "components/loading/letterLoading";
import DeviceStatusDetail from "components/modals/deviceStatusDetail";

export default class DevicesStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      level: -1,
      isLoading: true,
      devicesList: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      isShowStatus: false,
      deviceDetail: [],
      maintenanceList: [],
      serviceListDv: [],
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });
  updateShowStatus = async (device) => {
    const { getMasterParts, getPastStatus } = this.context;
    if (device?.name !== undefined) {
      await getMasterParts({ model: device?.model });
      await getPastStatus({ name: device?.name });
    }
    this.setState({
      isShowStatus: !this.state.isShowStatus,
      deviceDetail: device,
    });
  };

  async componentDidMount() {
    this.startLoading();
    await this.setDeviceData({ name: "", level: -1 });
    const data = {
      state: ["contacted", "draft", "contact_fail", "later", "process"],
      pic: null,
      uid: null,
    };
    this.setMaData(data);
    // setTimeout(() => this.setState({ isLoading: false }), 1000);
    this.stopLoading();
    this.getService();
  }

  setMaData = async (data) => {
    await this.context.getMA(data);
    this.setState({
      maintenanceList: this.context.maintenanceList
    });
      console.log("MAdata", this.state.maintenanceList)
  };

  getService = async () => {
    let result =  await this.context.getService();
    this.setState({
      serviceListDv: result
    });
    console.log("SVdata", this.state.serviceListDv)
    // console.log("machineData",this.context.machineList?.total_machine)
  };

  setDeviceData = async (data) => {
    await this.context.getAllLinkDevices(data);
    this.setState({
      devicesList: this.context.allDevicesList.slice(
        this.state.begin,
        this.state.end
      ),
    });
  };

  paginationUpdate = (e, data) => {
    const { allDevicesList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({ devicesList: [...allDevicesList.slice(beginIdx, endIdx)] });
  };

  createSearchDevices = () => {
    const { allDevicesList } = this.context;
    const { name, level } = this.state;

    const devicesOptions = allDevicesList?.map((device) => ({
      key: device.iotSerial,
      text: device.name,
      value: device.name,
    }));

    const statusOptions = [
      { key: "ทั้งหมด", text: "ทั้งหมด", value: -1 },
      { key: "พร้อมใช้งาน", text: "พร้อมใช้งาน", value: 0 },
      { key: "เตรียมซ่อม", text: "เตรียมซ่อม", value: 1 },
      { key: "ถึงกำหนดซ่อม", text: "ถึงกำหนดซ่อม", value: 2 },
      { key: "เลยกำหนดซ่อม", text: "เลยกำหนดซ่อม", value: 3 },
    ];

    return (
      <div className="search">
        <Form>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={devicesOptions}
              value={name}
              placeholder="หมายเลขเครื่องจักร"
              search
              onChange={(e, { value }) => this.setState({ name: value })}
            />
            <Form.Field
              control={Select}
              options={statusOptions}
              value={level}
              placeholder="สถานะอะไหล่"
              search
              onChange={(e, { value }) => this.setState({ level: value })}
            />
            <Button
              onClick={() => {
                this.setDeviceData({ name: "", level: -1 });
                this.setState({
                  name: "",
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({ name: name, level: level });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >ค้นหา
            </Button>
            &emsp;
            <Button 
              color="green" 
              href="/maintenance-list">
              <Icon name="wrench" /> 
              เพิ่มการแจ้งซ่อม 
            </Button>
          </Form.Group>
        </Form>
      </div>
    );
  };

  devicesTable = () => {
    const { devicesList } = this.state;
    console.log("devicesList",this.state.devicesList)
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ backgroundColor: "#abdbe3" }}>
              ชื่อผู้ใช้งาน
            </Table.HeaderCell>
            <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>จำนวนอะไหล่</Table.HeaderCell>
            <Table.HeaderCell>สถานะดำเนินการ</Table.HeaderCell>
            <Table.HeaderCell>แสดงสถานะ</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {devicesList?.map((device) => (
            <Table.Row key={device.iotSerial}>
              <Table.Cell>{device.user_id}</Table.Cell>
              <Table.Cell>{device.name}</Table.Cell>
              <Table.Cell>{device.total_part}</Table.Cell>
              <Table.Cell>
                {device.state === "draft"
                  ? "แจ้งลูกค้าเรียบร้อยแล้ว"
                  : device.state === "contact_fail"
                  ? "ติดต่อลูกค้าไม่ได้"
                  : device.state === "later"
                  ? "ติดต่ออีกครั้ง"
                  : device.state === "contacted"
                  ? "แจ้งซ่อมแล้ว"
                  : device.state === "received"
                  ? "SA รับเรื่องแล้ว"
                  : device.state === "processing"
                  ? "ดำเนินการซ่อม"
                  : device.state === "finish"
                  ? "ซ่อมเรียบร้อย"
                  : ""}
              </Table.Cell>
              <Table.Cell>
                <Button
                  className="action-btn"
                  color={
                    device.caution_level === 0
                      ? "green"
                      : device.is_complete === 0
                      ? "yellow"
                      : device.is_complete === 0
                      ? "red"
                      : "black"
                  }
                  onClick={() => {
                    this.updateShowStatus(device);
                  }}
                  style={{
                    fontFamily: "Kanit",
                    fontWeight: 200,
                    fontSize: "16px",
                  }}
                >
                  {device.caution_level === 0
                    ? "พร้อมใช้งาน"
                    : device.caution_level === 1
                    ? "รอติดตาม"
                    : device.caution_level === 2
                    ? "แจ้งลูกค้า"
                    : "แจ้งซ่อม"}
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  render() {
    const { isLoading, pageSize, isShowStatus, deviceDetail } = this.state
    return (
      <div className="devicesStatus">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="devicesStatus" />
        <Navigation />

        <DeviceStatusDetail
          isOpen={isShowStatus}
          isClose={this.updateShowStatus}
          deviceDetail={deviceDetail}
        />

        <div className="devicesStatus-content">
          <h2>ติดตามสถานะอะไหล่</h2>
          <hr />

          <div className="devicesStatus-content-search">
            {this.createSearchDevices()}
          </div>

          <div className="devicesStatus-content-devices">
            {this.devicesTable()}
          </div>

          <div className="devicesStatus-content-pagination">
            <Pagination
              activePage={this.state.activePage}
              totalPages={Math.ceil(
                this.context.allDevicesList.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

DevicesStatus.contextType = DeviceContext;
